import FunctionHelper from "./FunctionHelper";

/**
 * The SortHelper bundles useful static functions for sorting values
 */
export default abstract class SortHelper {
	/**
	 * Sort strings alphanumeric
	 */
	public static alphanum(a: string, b: string): number {
		for (let index: number = 0; FunctionHelper.exists(a[index]) && FunctionHelper.exists(b[index]); index++) {
			let aAlpha = a[index].replace(/[^a-zA-Z]/g, "");
			let bAlpha = b[index].replace(/[^a-zA-Z]/g, "");

			if (aAlpha === bAlpha) {
				let aNumber = FunctionHelper.applyValue(
					parseInt(a[index].replace(/[^0-9]/g, ""), 10), 0
				);
				let bNumber = FunctionHelper.applyValue(
					parseInt(b[index].replace(/[^0-9]/g, ""), 10), 0
				);

				if (aNumber === bNumber || isNaN(aNumber) || isNaN(bNumber)) {
					continue;
				}

				return aNumber > bNumber ? 1 : -1;
			} else if (aAlpha === "" && bAlpha !== "") {
				return -1;
			} else if (bAlpha === "" && aAlpha !== "") {
				return 1;
			} else {
				if (aAlpha.toUpperCase() === bAlpha.toUpperCase()) {
					return aAlpha > bAlpha ? 1 : -1;
				}

				return aAlpha.toUpperCase() > bAlpha.toUpperCase() ? 1 : -1;
			}
		}

		return a.length === b.length ? 0 : (a.length > b.length ? 1 : -1);
	};

	/**
	 * Sort anything numeric
	 */
	public static numeric(a: any, b: any): number {
		if (!FunctionHelper.exists(a)) {
			return -1;
		}

		if (!FunctionHelper.exists(b)) {
			return 1;
		}

		if (a > b) {
			return 1;
		} else if (a < b) {
			return -1;
		}

		return 0;
	};
}